import React from "react";
import { useEffect, useRef, useState } from "react";
import MonthRangePicker from "./monthRangePicker";
import monthPickStyle from "./monthPickParent.module.css";
import CalendarIcon from "../../Icons/CalendarIcon";

const MonthPickParent = ({
  getDateRangeState,
  applyFunc,
  cancelFunc,
  containerWidth,
  darkTheme,
  years,
  selectedPeriodRange,
  setYear,
  setGlobalStartMonth,
  setGlobalEndMonth,
}) => {
  const [open, setOpen] = useState(false);
  const [focusState, setFocusState] = useState(false);
  const parentRef = useRef(null);
  const [startMonth, setStartMonth] = useState({
    selectedFirstMonth: selectedPeriodRange?.startMonth,
    selectedFirstYear: selectedPeriodRange?.selectedYear,
  });
  const [endMonth, setEndMonth] = useState({
    selectedLastMonth: selectedPeriodRange?.endMonth,
    selectedLastYear: selectedPeriodRange?.selectedYear,
  });
  const togglePicker = () => {
    setOpen((prev) => !prev);
    setFocusState((prev) => !prev);
  };

  function digitToMonth(monthDigit) {
    const date = new Date(2000, monthDigit, 1);
    const monthName = date.toLocaleString("en-US", { month: "short" });
    return monthName;
  }

  useEffect(() => {
    if (!getDateRangeState) {
      return;
    }
    if (startMonth && startMonth.selectedFirstMonth !== null) {
      getDateRangeState(
        `${digitToMonth(startMonth.selectedFirstMonth)} ${
          startMonth.selectedFirstYear
        } - ${digitToMonth(endMonth.selectedLastMonth)} ${
          endMonth.selectedLastYear
        }`
      );
    } else {
      getDateRangeState("");
    }
  }, [startMonth]);

  const RenderPeriodRangeLabel = (startMonth, endMonth) => {
    if (startMonth.selectedFirstMonth || startMonth.selectedFirstMonth === 0)
    {
      if (endMonth?.selectedLastMonth == null)
      {
        return `${digitToMonth(startMonth.selectedFirstMonth)} ${
          startMonth.selectedFirstYear
        } - ${digitToMonth(startMonth.selectedFirstMonth)} ${
          endMonth.selectedLastYear
        }`;
      }
      else
        return `${digitToMonth(startMonth.selectedFirstMonth)} ${
                  startMonth.selectedFirstYear
                } - ${digitToMonth(endMonth.selectedLastMonth)} ${
                  endMonth.selectedLastYear
                }`;
    }
    else 
      return "Period Range";
  }

  return (
    <div className={`${monthPickStyle.mainContainer}`}>
      <div
        ref={parentRef}
        className={`${monthPickStyle.textField} ${
          darkTheme && monthPickStyle.textFieldDark
        } ${
          focusState
            ? darkTheme
              ? monthPickStyle.focusedBorderDark
              : monthPickStyle.focusedBorder
            : ""
        }`}
        onClick={togglePicker}
      >
        <div className={`${monthPickStyle.calender}`}><CalendarIcon /></div>
        <div
          className={`${monthPickStyle.dateView} ${
            darkTheme &&
            startMonth &&
            (startMonth.selectedFirstMonth ||
              startMonth.selectedFirstMonth === 0) &&
            monthPickStyle.dateViewDark
          }`}
        >
          {startMonth && RenderPeriodRangeLabel(startMonth, endMonth)}
        </div>
      </div>
      {open && (
        <MonthRangePicker
          containerWidth={containerWidth ? containerWidth : "324px"}
          setStartMonth={setStartMonth}
          setEndMonth={setEndMonth}
          openState={setOpen}
          focusState={setFocusState}
          parentRef={parentRef}
          applyFunc={applyFunc}
          cancelFunc={cancelFunc}
          darkTheme={darkTheme}
          years={years}
          selectedPeriodRange={selectedPeriodRange}
          setYear={setYear}
          setGlobalStartMonth={setGlobalStartMonth}
          setGlobalEndMonth={setGlobalEndMonth}
        />
      )}
    </div>
  );
};

export default MonthPickParent;
